"use strict";
exports.__esModule = true;
exports.isDeviceLocalizationSupported = void 0;
var semver_1 = require("semver");
var deviceVersionRangesForLocalization = {
    nanoX: ">=2.1.0",
    nanoSP: ">=1.1.0"
};
var isDeviceLocalizationSupported = function (seVersion, modelId) {
    return !!modelId &&
        !!deviceVersionRangesForLocalization[modelId] &&
        !!(0, semver_1.satisfies)((0, semver_1.coerce)(seVersion) || seVersion, deviceVersionRangesForLocalization[modelId]);
};
exports.isDeviceLocalizationSupported = isDeviceLocalizationSupported;
//# sourceMappingURL=localization.js.map